module.exports = __webpack_public_path__ + "static/media/type-modal.a2f4f082.svg";